'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_axios@0.18.1@axios/lib/cancel/isCancel.js
// module id = 252
// module chunks = 0